import React from 'react'

import Image from 'next/image'

import { Button, Text } from 'Components/UI'

import { ContactAvatarImage } from 'Assets/Images/Sections/WhyDoYouNeedActNow'

import { Content } from './styles'

type Props = {
  onAction?: () => void
}

function Card({ onAction }: Props) {
  return (
    <Content>
      <Image alt="Raj Narayan" src={ContactAvatarImage} />

      <Text bold important mb={2} mt={7} screen24>
        Raj Narayan
      </Text>

      <Text accent bold mb={8} screen20>
        Founder & Ceo | Hcp 8
      </Text>

      <Button onClick={onAction}>Book a Meeting</Button>
    </Content>
  )
}

export default Card
